import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/rv/rect.png'


const _withScopeId = n => (_pushScopeId("data-v-4b13ebc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "failed-reason-analysis" }
const _hoisted_2 = { class: "failed-reason-analysis-content" }
const _hoisted_3 = { class: "search-condition" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-overview" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "rect"
  }),
  /*#__PURE__*/_createElementVNode("strong", null, "激励申请核查失败原因分析")
], -1))
const _hoisted_5 = { class: "search-condition--wrapper" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "业务单元", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "核查轮次（年）", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "核查轮次（季度/月份）", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "项目期间（年）", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "项目期间（季度/月份）", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "分析维度", -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode("经销商名称")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("项目类型")
const _hoisted_14 = {
  key: 0,
  class: "label"
}
const _hoisted_15 = {
  key: 2,
  class: "label"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " ", -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_18 = { style: {"display":"flex","flex-direction":"row-reverse","padding":"8px 0"} }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_21 = { class: "table" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "table-title" }, "项目状态: 已结清", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "table-title" }, "项目状态: 未结清", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_BuSelector = _resolveComponent("BuSelector")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_tree_select = _resolveComponent("a-tree-select")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_DM = _resolveComponent("DM")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Breadcrumb, { dataSource: [] }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_a_space, {
              class: "interval",
              size: 5,
              direction: "vertical"
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _createVNode(_component_BuSelector, {
                  value: _ctx.bu,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bu) = $event)),
                  placeholder: "Please select",
                  style: {"width":"220px"},
                  onInitValue: _ctx.initValue,
                  onChange: _ctx.selectPayoutRound
                }, null, 8, ["value", "onInitValue", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_space, {
              class: "interval",
              size: 5,
              direction: "vertical"
            }, {
              default: _withCtx(() => [
                _hoisted_7,
                _createVNode(_component_a_date_picker, {
                  style: {"width":"220px"},
                  mode: "year",
                  valueFormat: "YYYY",
                  format: "YYYY",
                  value: _ctx.payoutRoundYear,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.payoutRoundYear) = $event)),
                  placeholder: "请选择",
                  open: _ctx.openPayoutRoundYear,
                  onOpenChange: _ctx.handlerOpenPayoutRoundChange,
                  onPanelChange: _ctx.handlerPanelPayoutRoundChange,
                  onChange: _ctx.changePayoutRoundYear
                }, null, 8, ["value", "open", "onOpenChange", "onPanelChange", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_space, {
              class: "interval",
              size: 5,
              direction: "vertical"
            }, {
              default: _withCtx(() => [
                _hoisted_8,
                _createVNode(_component_a_tree_select, {
                  maxTagCount: 2,
                  class: "sel-inp-size",
                  value: _ctx.payoutRoundMonth,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.payoutRoundMonth) = $event)),
                  style: {"width":"220px"},
                  "tree-checkable": "",
                  "tree-data": _ctx.qmOptions,
                  "show-checked-strategy": _ctx.SHOW_PARENT,
                  "allow-clear": "",
                  placeholder: "请选择",
                  disabled: !_ctx.payoutRoundYear
                }, null, 8, ["value", "tree-data", "show-checked-strategy", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_space, {
              class: "interval",
              size: 5,
              direction: "vertical"
            }, {
              default: _withCtx(() => [
                _hoisted_9,
                _createVNode(_component_a_date_picker, {
                  style: {"width":"220px"},
                  mode: "year",
                  valueFormat: "YYYY",
                  format: "YYYY",
                  value: _ctx.year,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.year) = $event)),
                  placeholder: "请选择",
                  open: _ctx.openProgramPeriodYear,
                  onOpenChange: _ctx.handlerOpenProgramPeriodChange,
                  onPanelChange: _ctx.handlerPanelProgramPeriodChange,
                  onChange: _ctx.changeYear
                }, null, 8, ["value", "open", "onOpenChange", "onPanelChange", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_space, {
              class: "interval",
              size: 5,
              direction: "vertical"
            }, {
              default: _withCtx(() => [
                _hoisted_10,
                _createVNode(_component_a_tree_select, {
                  maxTagCount: 2,
                  class: "sel-inp-size",
                  value: _ctx.quarter,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.quarter) = $event)),
                  style: {"width":"220px"},
                  "tree-checkable": "",
                  "tree-data": _ctx.qmOptions,
                  "show-checked-strategy": _ctx.SHOW_PARENT,
                  "allow-clear": "",
                  placeholder: "请选择",
                  disabled: !_ctx.year
                }, null, 8, ["value", "tree-data", "show-checked-strategy", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_space, {
              class: "interval",
              size: 5,
              direction: "vertical"
            }, {
              default: _withCtx(() => [
                _hoisted_11,
                _createVNode(_component_a_select, {
                  allowClear: "",
                  style: {"width":"220px"},
                  onChange: _ctx.clearDynamic,
                  value: _ctx.dataView,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dataView) = $event)),
                  disabled: _ctx.isDealer,
                  placeholder: _ctx.isDealer ? '项目类型' : '请选择'
                }, {
                  default: _withCtx(() => [
                    (!_ctx.isDealer)
                      ? (_openBlock(), _createBlock(_component_a_select_option, {
                          key: 0,
                          value: "Dealer"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_a_select_option, { value: "Program Category" }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onChange", "value", "disabled", "placeholder"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_space, {
              class: "interval",
              size: 5,
              direction: "vertical"
            }, {
              default: _withCtx(() => [
                (!_ctx.dataView)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_14, " "))
                  : _createCommentVNode("", true),
                (!_ctx.dataView)
                  ? (_openBlock(), _createBlock(_component_a_input, {
                      key: 1,
                      style: {"width":"220px"},
                      disabled: "",
                      placeholder: "请选择分析维度"
                    }))
                  : _createCommentVNode("", true),
                (_ctx.dataView)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_15, _toDisplayString(_ctx.dataView !== "Program Category" ? "经销商名称" : "项目类型"), 1))
                  : _createCommentVNode("", true),
                (
                _ctx.dataView === 'Sub Region' ||
                _ctx.dataView === 'Program Category' ||
                _ctx.dataView === 'Region'
              )
                  ? (_openBlock(), _createBlock(_component_a_select, {
                      key: 3,
                      mode: "multiple",
                      maxTagCount: 1,
                      maxTagTextLength: 3,
                      value: _ctx.dynamicArray,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dynamicArray) = $event)),
                      allowClear: "",
                      style: {"width":"220px"},
                      placeholder: "请选择"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.temporaryArray, (item) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: item.key,
                            value: item.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.value), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value"]))
                  : _createCommentVNode("", true),
                (_ctx.dataView === 'Dealer' || _ctx.dataView === 'Dealer Group')
                  ? (_openBlock(), _createBlock(_component_a_select, {
                      key: 4,
                      value: _ctx.dynamicArrayObj,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dynamicArrayObj) = $event)),
                      mode: "multiple",
                      "label-in-value": "",
                      placeholder: "请输入...",
                      style: {"width":"220px"},
                      "filter-option": false,
                      "not-found-content": _ctx.fetching ? undefined : null,
                      onSearch: _ctx.fetchUser,
                      options: _ctx.userData,
                      maxTagTextLength: 5,
                      maxTagCount: 1
                    }, _createSlots({ _: 2 }, [
                      (_ctx.fetching)
                        ? {
                            name: "notFoundContent",
                            fn: _withCtx(() => [
                              _createVNode(_component_a_spin, { size: "small" })
                            ])
                          }
                        : undefined
                    ]), 1032, ["value", "not-found-content", "onSearch", "options"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_a_space, {
              class: "interval",
              size: 5,
              direction: "vertical"
            }, {
              default: _withCtx(() => [
                _hoisted_16,
                _createVNode(_component_a_button, { onClick: _ctx.reset }, {
                  default: _withCtx(() => [
                    _hoisted_17
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_18, [
              (_ctx.$btnPermissions('FRA002'))
                ? (_openBlock(), _createBlock(_component_a_space, {
                    key: 0,
                    style: {"margin-right":"10px"},
                    class: "interval",
                    size: 5,
                    direction: "vertical"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: _ctx.getTableData
                      }, {
                        default: _withCtx(() => [
                          _hoisted_19
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.$btnPermissions('FRA001'))
                ? (_openBlock(), _createBlock(_component_a_space, {
                    key: 1,
                    style: {"margin-right":"10px"},
                    class: "interval",
                    size: 5,
                    direction: "vertical"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, { onClick: _ctx.download }, {
                        default: _withCtx(() => [
                          _hoisted_20
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", null, [
            _hoisted_22,
            _createVNode(_component_a_table, {
              scroll: { y: _ctx.tableHeight },
              pagination: false,
              columns: _ctx.columns,
              "data-source": _ctx.dataSource,
              bordered: ""
            }, null, 8, ["scroll", "columns", "data-source"])
          ]),
          _createElementVNode("div", null, [
            _hoisted_23,
            _createVNode(_component_a_table, {
              scroll: { y: _ctx.tableHeight },
              pagination: false,
              columns: _ctx.nonClosedColumns,
              "data-source": _ctx.nonClosedDataSource,
              bordered: ""
            }, null, 8, ["scroll", "columns", "data-source"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_DM, {
      language: "CN",
      onDownloadAction: _ctx.handleOk,
      downloadVisible: _ctx.downloadTypeVisible,
      onCloseAction: _cache[8] || (_cache[8] = ($event: any) => (_ctx.downloadTypeVisible = false)),
      downloadTableData: _ctx.downloadTableData
    }, null, 8, ["onDownloadAction", "downloadVisible", "downloadTableData"])
  ], 64))
}